export default "__VITE_ASSET__BTJxMj3M__"